// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

export const SHOW_EDIT_FORM = 'show_edit_form'
export const SHOW_ADD_FORM = 'show_add_form'
export const CHECK_ITEMS = 'check_items'
export const CHANGE_CHECK_ALL_BOX = 'change_check_all_box'

export function showEditForm (formNumber) {
  return (dispatch) => {
    dispatch({
      type: SHOW_EDIT_FORM,
      payload: formNumber
    })
  }
}

export function showAddForm () {
  return (dispatch) => {
    dispatch({
      type: SHOW_ADD_FORM,
    })
  }
}

export function checkItems (item, formName) {
  return (dispatch) => {
    dispatch({
      type: CHECK_ITEMS,
      payload: {
        formName: formName,
        item: item
      }
    })
  }
}

export function changeCheckAllBoxState (checkAll, keepChecked) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_CHECK_ALL_BOX,
      payload: {
        checkAll: checkAll,
        keepChecked: keepChecked
      }
    })
  }
}
